import { render, staticRenderFns } from "./PaymentPromoOld.vue?vue&type=template&id=68a1f7b4&scoped=true"
import script from "./PaymentPromoOld.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentPromoOld.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PaymentPromoOld.vue?vue&type=style&index=0&id=68a1f7b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a1f7b4",
  null
  
)

export default component.exports